// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1B0dZ","vertical":"Tabs_vertical__1sbr0","centered":"Tabs_centered__1B_hC"};